import { render, staticRenderFns } from "./MasterInterlining.vue?vue&type=template&id=72fd0d5e&"
import script from "./MasterInterlining.vue?vue&type=script&lang=js&"
export * from "./MasterInterlining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports